 
import BigNumber from 'bignumber.js'
 
  // User Contract Create Functions Start
  
  export const CreateStandartToken = async (FactoryContract,ref,name,symbol,decimals,totalSupply,mintable,amount,account) => {
    return FactoryContract.methods
      .createStandartToken(ref,name,symbol,decimals,totalSupply,mintable)
      .send({ from: account , value: new BigNumber(amount).times(new BigNumber(10).pow(18)).toString()})
      .on('transactionHash', (tx) => {
        return tx
      })
  }

  export const CreateLiquidityGeneratorBurnToken = async (FactoryContract,ref,name,symbol,decimals,totalSupply,router,marketingAddress,taxfee,liqfee,marketingfee,burnfee,amount,account) => {
    return FactoryContract.methods
      .createLiquidityGeneratorBurnToken(ref,name,symbol,decimals,totalSupply,router,marketingAddress,taxfee,liqfee,marketingfee,burnfee)
      .send({ from: account , value: new BigNumber(amount).times(new BigNumber(10).pow(18)).toString()})
      .on('transactionHash', (tx) => {
        return tx
      })
  }

  export const CreateLiquidityGeneratorToken = async (FactoryContract,ref,name,symbol,decimals,totalSupply,router,charitiywallet,taxfee,liqfee,charityfee,amount,account) => {
    return FactoryContract.methods
      .createLiquidityGeneratorToken(ref,name,symbol,decimals,totalSupply,router,charitiywallet,taxfee,liqfee,charityfee)
      .send({ from: account , value: new BigNumber(amount).times(new BigNumber(10).pow(18)).toString()})
      .on('transactionHash', (tx) => {
        return tx
      })
  }

  // User Contract Create Functions End

  // Token Contract Calls start

  export const mint = async (StandardMintableToken,address,amount,account) => {
    return StandardMintableToken.methods
      .mint(address,amount)
      .send({ from: account })
      .on('transactionHash', (tx) => {
        return tx
      })
  }

  export const Approve = async (TokenContractAddress, address  ,amount , account) => {
    return TokenContractAddress.methods
      .approve(address,amount)
      .send({ from: account})
      .on('transactionHash', (tx) => {
        return tx
      })
  }

  export const Transfer = async (TokenContractAddress, address  ,amount , account) => {
    return TokenContractAddress.methods
      .transfer(address,amount)
      .send({ from: account})
      .on('transactionHash', (tx) => {
        return tx
      })
  }

  export const TransferOwner = async (TokenContractAddress, address , account) => {
    return TokenContractAddress.methods
      .transferOwnership(address)
      .send({ from: account})
      .on('transactionHash', (tx) => {
        return tx
      })
  }

  export const ExcludeFromFee = async (TokenContractAddress, address , account) => {
    return TokenContractAddress.methods
      .excludeFromFee(address)
      .send({ from: account})
      .on('transactionHash', (tx) => {
        return tx
      })
  }

  export const IncludeInFee = async (TokenContractAddress, address , account) => {
    return TokenContractAddress.methods
      .includeInFee(address)
      .send({ from: account})
      .on('transactionHash', (tx) => {
        return tx
      })
  }

  export const SetTaxFee = async (TokenContractAddress,fee, account) => {
    return TokenContractAddress.methods
      .setTaxFeePercent(fee)
      .send({ from: account})
      .on('transactionHash', (tx) => {
        return tx
      })
  }

  export const SetLiqFee = async (TokenContractAddress,fee, account) => {
    return TokenContractAddress.methods
      .setLiquidityFeePercent(fee)
      .send({ from: account})
      .on('transactionHash', (tx) => {
        return tx
      })
  }

  export const SetMarketingFee = async (TokenContractAddress,fee, account) => {
    return TokenContractAddress.methods
      .setMarketingFeePercent(fee)
      .send({ from: account})
      .on('transactionHash', (tx) => {
        return tx
      })
  }

  export const SetBurnFee = async (TokenContractAddress,fee, account) => {
    return TokenContractAddress.methods
      .setBurnFeePercent(fee)
      .send({ from: account})
      .on('transactionHash', (tx) => {
        return tx
      })
  }

  export const SetMarketingWallet = async (TokenContractAddress,address, account) => {
    return TokenContractAddress.methods
      .setMarketingWallet(address)
      .send({ from: account})
      .on('transactionHash', (tx) => {
        return tx
      })
  }


  // Token Contract Calls end